import { Axios } from "../../../axios";

export function get_applications({ dispatch, commit }) {
	Axios.get("/applications")
		.then(function(response) {
			commit("set_applications", response.data.data);
		})
		.catch(function(error) {
			commit("set_applications", {});

			if (
				error &&
				error.response &&
				error.response.status &&
				error.response.status === 401
			) {
				dispatch("logout_user");
			}
		});
}

export function create_application({ dispatch, commit, getters }, payload) {
	let app = {
		institutions: payload.campuses,
		applicantType: payload.trad,
		studentType: payload.year
	};
	Axios.put("/application", app)
		.then(function(response) {
			app.id = response.data.data.sappId;
			if (getters["userType"] === "authed") {
				dispatch("get_applications");
			} else {
				commit("set_applications", [app]);
			}
			commit("set_active_application", app.id);
		})
		.catch(function(error) {
			if (
				error &&
				error.response &&
				error.response.status &&
				error.response.status === 400
			) {
				let errors = error.response.data.message;
				for (let i = 0; i < errors.length; i++) {
					dispatch("add_alert", {
						variant: "danger",
						msg: errors[i]
					});
				}
			} else {
				dispatch("add_alert", {
					variant: "danger",
					msg: "Unable to save your changes."
				});
			}
		});
}

export function edit_application({ dispatch, commit }, payload) {
	let app = {
		id: payload.app_id,
		institutions: payload.campuses,
		applicantType: payload.trad,
		studentType: payload.year
	};
	Axios.post("/application", app)
		.then(function() {
			commit("set_active_application", null);
			commit("clear_alerts");
		})
		.catch(function(error) {
			if (error.response.status !== 400) {
				dispatch("add_alert", {
					variant: "danger",
					msg: "Unable to save your changes."
				});
			} else {
				let errors = error.response.data.message;
				for (let i = 0; i < errors.length; i++) {
					dispatch("add_alert", {
						variant: "danger",
						msg: errors[i]
					});
				}
			}
		});
}

export function submit_application({ dispatch, commit, getters }) {
	Axios.put("/submit-application", { app_id: getters.active_application_id })
		.then(function() {
			commit("set_application_status", "submitted");
			commit("clear_alerts");
		})
		.catch(function(error) {
			commit("clear_alerts");
			if (error.response.status !== 400) {
				dispatch("add_alert", {
					variant: "danger",
					msg: "Unable to submit your application at this time."
				});
			} else {
				let errors = error.response.data;
				for (let i = 0; i < errors.length; i++) {
					dispatch("add_alert", {
						variant: "danger",
						msg: errors[i]
					});
				}
			}
		});
}

export function get_application_data({ dispatch, commit }, app_id) {
	commit("set_application_status", null);
	Axios.get("/application/" + app_id)
		.then(function(response) {
			let data = response.data.data.questions;
			for (let i = 0; i < data.length; i++) {
				commit(data[i].slug + "/set_answer", data[i].answer, { root: true });
				commit(data[i].slug + "/set_is_required", data[i].is_required, {
					root: true
				});
				commit(data[i].slug + "/set_is_displayed", data[i].is_displayed, {
					root: true
				});
			}
			commit("set_application_status", "loaded");
		})
		.catch(function(error) {
			if (error && error.response && error.response.status === 400) {
				let errors = error.response.data;
				for (let i = 0; i < errors.length; i++) {
					dispatch("add_alert", {
						variant: "danger",
						msg: errors[i]
					});
				}
			} else {
				commit("set_active_application", null);
				dispatch("add_alert", {
					variant: "danger",
					msg: "Unable to load your application at this time."
				});
			}
		});
}
